import { changelog } from '@/mocks/downloadData';

export default function Changelog() {
  return (
    <section id="changelog" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
              <i className="ri-history-line"></i>
              CHANGELOG
            </span>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
              版本更新记录
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              我们在持续修复问题并优化体验。保持使用最新版本，可以减少已知问题的发生。
            </p>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 ml-2">
              {changelog.map((item) => (
                <li key={item.version} className="ml-6 pb-8 last:pb-0">
                  <span className="absolute -left-[7px] mt-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-100"></span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-xl text-foreground-950 tracking-wide">{item.version}</span>
                    {item.badge && (
                      <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs">{item.badge}</span>
                    )}
                    <span className="text-foreground-500 text-xs">{item.date}</span>
                  </div>
                  <ul className="mt-3 space-y-2">
                    {item.items.map((text, idx) => (
                      <li key={`${item.version}-${idx}`} className="flex items-start gap-2 text-foreground-700 text-sm">
                        <i className="ri-checkbox-blank-circle-fill text-[6px] text-secondary-500 mt-2"></i>
                        <span className="leading-relaxed">{text}</span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}